export default __webpack_public_path__ + "static/media/Arch_AWS-CodeBuild_64.fc775691.svg";